import { forwardRef, useImperativeHandle, useState } from "react";

export type DebugConsoleHandle = {
    log: (msg: string) => void;
    clear: () => void;
};

const DebugConsole = forwardRef<DebugConsoleHandle>((_, ref) => {
    const [logs, setLogs] = useState<string[]>([]);

    useImperativeHandle(ref, () => ({
        log(msg: string) {
            setLogs((prev) => [...prev, msg]);
        },
        clear() {
            setLogs([]);
        },
    }));

    return <pre className="debug-console">{logs.join("\n")}</pre>;
});

export default DebugConsole;